// extracted by mini-css-extract-plugin
export default {"Container":"styles_Container__pcDZB","section-1":"styles_section-1__dORW6","content":"styles_content__R-pe2","section-2":"styles_section-2__ajZoK"};